import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  setCircuitBreakerConfig,
  setFeedConfig,
  setFeedConfigHistory,
  setFeedConfigUniqueCreator,
  setLoading,
} from 'redux/actions/FeedConfig';
import { displayMessage } from 'redux/actions/Ui';
import {
  GET_CIRCUIT_BREAKER_CONFIG,
  GET_FEED_CONFIG,
  GET_FEED_CONFIG_HISTORY,
  GET_FEED_CONFIG_UNIQUE_CREATOR,
  UPDATE_CIRCUIT_BREAKER_CONFIG,
  UPDATE_FEED_CONFIG,
} from 'redux/constants/FeedConfig';
import { env } from 'configs/EnvironmentConfig';
import fetch, { errorHandler } from 'auth/FetchInterceptor';
import setNotification from 'components/shared-components/Notification';

export function* getFeedConfig() {
  yield takeLatest(GET_FEED_CONFIG, function* (action) {
    try {
      yield put(setLoading(true));
      const response = yield call(() => {
        return fetch({
          method: 'post',
          url: env.API_ENDPOINT_URL + '/feed-config/get-feed-config   ',
          data: action.payload,
          withCredentials: true,
        });
      });
      yield put(setFeedConfig(response.data));
    } catch (error) {
      // setNotification({ message: 'Failed to get config', type: 'error' });
      errorHandler(error, 'Failed to get config');
    } finally {
      yield put(setLoading(false));
    }
  });
}

export function* updateFeedConfig() {
  yield takeLatest(UPDATE_FEED_CONFIG, function* (action) {
    try {
      yield put(setLoading(true));
      const response = yield call(() => {
        return fetch({
          method: 'post',
          url: env.API_ENDPOINT_URL + '/feed-config/update-feed-config   ',
          data: action.payload,
          withCredentials: true,
        });
      });
      yield put(setFeedConfig(response.data));
      setNotification({
        message: 'Circuit breaker notification updated successfully',
        type: 'success',
      });
    } catch (error) {
      // setNotification({
      //   message: 'Failed to update config',
      //   type: 'error',
      // });
      errorHandler(error, 'Failed to update config');
    } finally {
      yield put(setLoading(false));
    }
  });
}

export function* getFeedConfigUniqueCreator() {
  yield takeLatest(GET_FEED_CONFIG_UNIQUE_CREATOR, function* (action) {
    try {
      yield put(setLoading(true));
      const response = yield call(() => {
        return fetch({
          method: 'post',
          url: env.API_ENDPOINT_URL + '/source-feeds/get-circuit-breaker-user',
          data: action.payload,
          withCredentials: true,
        });
      });
      yield put(setFeedConfigUniqueCreator(response.data));
    } catch (error) {
      // setNotification({
      //   message: 'Failed to get unique creator',
      //   type: 'error',
      // });
      errorHandler(error, 'Failed to get unique creator');
    } finally {
      yield put(setLoading(false));
    }
  });
}

export function* getFeedConfigHistory() {
  yield takeLatest(GET_FEED_CONFIG_HISTORY, function* (action) {
    try {
      yield put(setLoading(true));
      const response = yield call(() => {
        return fetch({
          method: 'post',
          url: env.API_ENDPOINT_URL + '/source-feeds/history-report',
          data: action.payload,
          withCredentials: true,
        });
      });
      yield put(setFeedConfigHistory(response.data));
    } catch (error) {
      // setNotification({ message: 'Failed to get history', type: 'error' });
      errorHandler(error, 'Failed to get history');
    } finally {
      yield put(setLoading(false));
    }
  });
}

export function* getCircuitBreakerConfig() {
  yield takeLatest(GET_CIRCUIT_BREAKER_CONFIG, function* (action) {
    try {
      yield put(setLoading(true));
      const response = yield call(() => {
        return fetch({
          method: 'post',
          url:
            env.API_ENDPOINT_URL + '/source-feeds/get-circuit-breaker-config',
          data: action.payload,
          withCredentials: true,
        });
      });
      yield put(setCircuitBreakerConfig(response.data.SourceFeedConfig));
    } catch (error) {
      // setNotification({
      //   message: 'Failed to get circuit breaker config',
      //   type: 'error',
      // });
      errorHandler(error, 'Failed to get circuit breaker config');
    } finally {
      yield put(setLoading(false));
    }
  });
}

export function* updateCircuitBreakerConfig() {
  yield takeLatest(UPDATE_CIRCUIT_BREAKER_CONFIG, function* (action) {
    try {
      yield put(setLoading(true));
      const response = yield call(() => {
        return fetch({
          method: 'post',
          url:
            env.API_ENDPOINT_URL +
            '/source-feeds/update-circuit-breaker-config',
          data: action.payload,
          withCredentials: true,
        });
      });
      yield put(setFeedConfigHistory(response.data));
      setNotification({
        message: 'Circuit breaker updated successfully',
        type: 'success',
      });
    } catch (error) {
      // setNotification({
      //   message: 'Failed to update circuit breaker',
      //   type: 'error',
      // });
      errorHandler(error, 'Failed to update circuit breaker');
    } finally {
      yield put(setLoading(false));
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getFeedConfig),
    fork(updateFeedConfig),
    fork(getFeedConfigUniqueCreator),
    fork(getFeedConfigHistory),
    fork(getCircuitBreakerConfig),
    fork(updateCircuitBreakerConfig),
  ]);
}
